import {ValidationStepConfig} from 'src/types/form';
import {BaseForm} from 'src/types/onboarding';
import {RegistrationSteps} from 'src/types/enums';
import AchievementSelection from './AchievementSelection';
import {noop} from 'lodash';

export default AchievementSelection;

export const AchievementSelectionConfig: ValidationStepConfig<BaseForm, void> = {
  key: RegistrationSteps.ACHIEVEMENT_SELECT,
  Component: AchievementSelection,
  validate: noop,
};
